<template>
  <div class="live">
    <div class="title">
      <h3>
        <i class="el-icon-arrow-left"></i> 新增产品
        <span>带<i>*</i>为必填项</span>
      </h3>
    </div>
    <div class="tixing">
      <h4>重要提醒</h4>
      <p>
        建议您在<i>2023年8月30</i>日前完成资料填写及上传。产品资料愈丰富，曝光机会愈多前完成资料填写及上传。产品资料愈丰富，曝光机会愈多。
      </p>
    </div>
    <!-- 表单元素-------------------------- -->
    <div class="formdata">
      <el-form ref="form" :model="sizeForm" label-width="200px" size="mini">
        <el-form-item label="直播名称·中文:" :required="true">
          <el-input
            v-model="sizeForm.live_name"
            placeholder="请输入直播名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="直播名称·英文:">
          <el-input
            v-model="sizeForm.englishName"
            placeholder="请输入直播名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间:" :required="true">
          <el-input
            v-model="sizeForm.englishName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="结束时间:">
          <el-input
            v-model="sizeForm.englishName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传直播封面图片:">
          <el-upload
            drag
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-remove="handleRemove"
            v-if="flag"
          >
            <div class="el-upload__text">选择文件</div>
          </el-upload>

          <div class="imgBox" v-else>
            <img :src="i.imgUrl" alt="" v-for="(i, k) in imgArr" :key="k" />
          </div>
          <p class="tishi">
            格式：jpg, png, gif; 建议尺寸：693*399px; 大小：2M内
          </p>
        </el-form-item>
        <el-form-item label="视频类型:" :required="true">
          <el-row>
            <el-radio v-model="radio" label="1">上传视频</el-radio>
            <el-radio v-model="radio" label="2">直播外链</el-radio>
            <el-radio v-model="radio" label="3">直播入口二维码</el-radio>
          </el-row>
          <el-row>
            <el-input
              v-if="radio == 2"
              v-model="sizeForm.address"
              placeholder="请输入直播链接地址"
            ></el-input>
            <el-upload
              v-else
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="handleChange"
              :file-list="fileList"
            >
              <div class="shangchuan">
                <el-button size="small" class="select" type="primary"
                  >点击上传</el-button
                >
              </div>
              <div slot="tip" class="el-upload__tip">
                格式：mp4；mov; 大小：100M内
              </div>
            </el-upload>
          </el-row>
        </el-form-item>
        <el-form-item label="直播简介·中文:" :required="true">
          <tinymce></tinymce>
        </el-form-item>
        <el-form-item label="直播简介·英文:" :required="true"> </el-form-item>
        <el-button type="primary" class="button" @click="submitForm('sizeForm')"
          >提交</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import tinymce from "../../comment/tinymce.vue";
import tinymce2 from "../../comment/tinymce.vue";
export default {
  name: "addExhiLive",
  data() {
    return {
      sizeForm: {
        live_name: "", //直播名称
        englishName: "", //英文名字
        address: "", //直播外链地址
      },
      imgArr: [], //查看上传的图片列表
      flag: true,
      radio: "1", //直播类型选择
    };
  },

  components: {
    tinymce,
    tinymce2,
  },

  computed: {},

  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.live {
  margin: 17px 26px 20px 26px;
  box-sizing: border-box;
  padding: 18px 26px 0 0;
  .title {
    height: 55px;
    padding-left: 26px;
    border-bottom: 1px solid #e8e8e8;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
  }
  .tixing {
    margin-left: 26px;
    margin-bottom: 40px;
    h4 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff190c;
      line-height: 19px;
      margin-bottom: 9px;
      margin-top: 26px;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
      i {
        font-style: normal;
        color: red;
      }
    }
  }
  .formdata {
    width: 650px;
    margin-top: 48px;
    margin: 0 auto;
    .tishi {
      margin-top: 30px;
      font-size: 12px;
      color: #999999;
    }
    .editor {
      width: 463px;
      height: 193px;
    }
    .shangchuan {
      width: 208px;
      height: 117px;
      border: 1px solid #e9e9e9;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f1f1f1;
      button {
        width: 94px;
        height: 28px;
        color: #666;
        background: white;
        border: 1px solid #e9e9e9;
      }
    }
    .button {
      margin-left: 90px;
      background: #006fb8;
      opacity: 0.5;
    }
  }
}
</style>
<style scoped>
.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}

.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 93px;
  height: 28px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 27px;
}
</style>